import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

type UptimeChartProps = {
  index: number;
  uptime: number;
};

const UptimeChart = ({ index, uptime }: UptimeChartProps) => {
  const getDonutColor = (percentageValue: number) => {
    let color;
    if (percentageValue >= 60) {
      color = '#405fb9';
    } else if (percentageValue >= 30 && percentageValue < 60) {
      color = '#ccbb00';
    } else if (percentageValue < 30) {
      color = '#86002d';
    }
    return color;
  };

  const donutChartData = [
    {
      name: 'uptime',
      value: uptime,
      color: getDonutColor(uptime),
    },
    {
      name: 'downtime',
      value: 100 - uptime,
      color: '#FFFFFF',
    },
  ];

  return (
    <div className="d-flex align-items-center">
      <div style={{ height: '52px', width: '52px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={donutChartData}
              dataKey="value"
              innerRadius={8}
              outerRadius={15}
              startAngle={90}
              endAngle={-270}
              stroke="none"
            >
              {donutChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <span>{`${uptime}%`}</span>
    </div>
  );
};

export default UptimeChart;
